import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addError } from '../redux/alerts';
import { getEPayLink } from '../services/nodusService';
import LoadingScreen from './LoadingScreen';
import useCustomerNumber from '../hooks/useCustomerNumber';

type PaymentRedirectProps = {
  fallbackPath?: string;
};

const PaymentRedirect = ({ fallbackPath = '/practice/dashboard' }: PaymentRedirectProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customerNumber = useCustomerNumber();

  const redirectToPayments = async () => {
    try {
      const link = await getEPayLink(customerNumber, 'payments');
      window.location.replace(link);
    } catch {
      dispatch(addError('Failed to open payment link'));
      navigate(fallbackPath);
    }
  };

  useEffect(() => {
    if (customerNumber) {
      redirectToPayments();
    }
  }, [customerNumber]);

  return <LoadingScreen />;
};

export default PaymentRedirect;
